import React, { FC } from 'react';

import { DedicatedRouteProps } from 'home/view/check-feasibility/comp-generator/common-interface';
import CheckFeasibility from './check-feasibility';

interface Props {}

export const AuthView: FC<DedicatedRouteProps> = (props) => {
  return (
    <div className="auth-view">
      <CheckFeasibility {...props} />
    </div>
  );
};

export default AuthView;
